module.exports = __webpack_public_path__ + "campfire-logo.png";